/**
 * Canonical table of Brazilian states (UF). The UF acronym is the source of
 * truth; the full name is derived from it (see reference doc 03 §1.2).
 */

/**
 * Map of UF acronym to full state name (all 27 federative units).
 * @type {Record<string, string>}
 */
export const BRAZIL_STATES = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
};

/**
 * Resolves a UF acronym to its full state name.
 * @param {string} uf - State acronym (case-insensitive, e.g. 'sp').
 * @returns {string} The full state name, or the original value if unknown.
 */
export const ufToName = uf => BRAZIL_STATES[(uf || '').toUpperCase()] || uf;

/**
 * Resolves a full state name to its UF acronym.
 * @param {string} name - Full state name (e.g. 'São Paulo').
 * @returns {string} The UF acronym, or the original value if unknown.
 */
export const nameToUf = name =>
  Object.keys(BRAZIL_STATES).find(uf => BRAZIL_STATES[uf] === name) || name;

/**
 * Options array for select inputs: `[{ value: 'SP', label: 'São Paulo' }, ...]`.
 * @type {Array<{ value: string, label: string }>}
 */
export const STATE_OPTIONS = Object.entries(BRAZIL_STATES).map(
  ([value, label]) => ({ value, label })
);
